import { Formik } from 'formik'
import React from 'react'
import { AddressFormData } from '../../types'
import AddressForm from './AddressForm'
import useAddressValidation from '../../hooks/validation/use-address-validation'
import { FormStepProps } from 'src/Libs/installation-statement/components/types'
import { Box, Grid, Typography } from '@mui/material'
import { buildLabelWithRequiredPrefix } from 'src/Libs/form'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/**
 * Component for the installation statement wizard address step
 */
const Address: React.VFC<FormStepProps<AddressFormData>> = ({ data, setFormData, setFinalValidation, setTouched }) => {
  const { t } = useCustomTranslation()
  const { inProgressValidationSchema, finalValidationSchema } = useAddressValidation()

  const handleValidationForFinalValidationSchema = async (values: AddressFormData): Promise<void> => {
    const response = await finalValidationSchema.isValid(values)
    setFinalValidation(response)
  }

  return (
    <Grid container sx={{ flexDirection: 'column' }} spacing={0}>
      {/*eslint-disable-next-line @typescript-eslint/no-empty-function*/}
      <Formik initialValues={data} onSubmit={() => {}} validationSchema={inProgressValidationSchema} validateOnMount>
        {formData => {
          if (formData.dirty) {
            setTouched(true)
          }

          setFormData(formData)

          handleValidationForFinalValidationSchema(formData.values)
          return <AddressForm />
        }}
      </Formik>
      <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: 2 }}>
        <Typography variant="caption">{buildLabelWithRequiredPrefix(t('common.required'))}</Typography>
      </Box>
    </Grid>
  )
}

export default Address
